<div class="container">
  <div class="row">
    <div class="col-md-6" style="color:black; padding-top:1%; font-size:1.4em; font-weight:bold ">
      In re Generic Pharmaceuticals Antitrust Litigation
    </div>
    <div class="col-md-6">
      <div class="float-right phoneNumber" style="font-size: 1.4em; padding-top: 3%; font-weight: bold">1-877-316-0171</div>
    </div>
    <div class="col-md-12" style="padding-left:0px; padding-right:0px">

    </div>
  </div>
</div>
<header>
  <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light  border-bottom " style="background-color: #000042 ">
    <div class="container">
      <button class="navbar-toggler" type="button" style="background-color:white" data-toggle="collapse" data-target=".navbar-collapse" aria-label="Toggle navigation" [attr.aria-expanded]="isExpanded" (click)="toggle()">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse justify-content-center" [ngClass]="{ show: isExpanded }">
        <ul class="navbar-nav flex-grow">
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/landing']" style="color:white; font-weight:bold">All Classes Page</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link  hover_lightBlue" [routerLink]="['/apotex-heritage-classes-homepage']" style="color:white; font-weight:bold">Home</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link  hover_lightBlue" [routerLink]="['/home']" style="color:white; font-weight:bold">File a Claim</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link  hover_lightBlue" [routerLink]="['/apotex-heritage-classes-notice']" style="color:white; font-weight:bold">Notice/FAQs</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/apotex-heritage-classes-courtdocuments']" style="color:white; font-weight:bold">Court Documents</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/apotex-heritage-classes-contact']" style="color:white; font-weight:bold">Contact Information</a>
          </li>

        </ul>
      </div>
    </div>
  </nav>

</header>
<div class="container" style="border:1px solid #bebaba">
  <div class="row text-center background-bottom">
    <div class="col-md-12 text-center img-fluid" style="margin-top:2%; margin-bottom:2%; padding-right:2%; padding-left:2%">
      <p class="text-center" style="font-size:1.0em; color:white">
        This official website is maintained by the Notice Administrator for <i>In re Generic Pharmaceuticals Antitrust Litigation</i>,
        No. 16-MD-2724 pending in the United States District Court for the Eastern District of Pennsylvania.
      </p>
    </div>
  </div>
  <br />
  <div class="row indentContent">
    <div class="col-md-12">
      <h2 class="#353535" id="FontTwo"><b>Court Documents</b></h2><br />

      <h6>Court Documents Relating to BOTH the Apotex and Heritage Settlements</h6>
      <ul>
        <li>
          <a href="../../../../assets/2026-06-10 Order.pdf" target="_blank">
            2026-06-10 Order Approving Notices, Notice Plan, Claim Forms & Appointment of Claims Admin
          </a>
        </li>
        <li>
          <a href="../../../../assets/Docs/ApotexHeritageSettlements/2025-11-26 List of Entities that Opted Out of Settlement.pdf" target="_blank">
            2025-11-26 List of Entities that Opted Out of Settlement
          </a>
        </li>
        <li>
          <a href="../../../assets/Docs/20741499-0--27359.pdf" target="_blank">
            2025-11-19 Order Barring Interference with Distribution of Funds
          </a>
        </li>
        <li>
          <a href="../../../assets/Docs/2025-11-18 Notice and 2d Declaration  WRT False_Misleadings Commns to Class Members (ECF 3808-09).pdf" target="_blank">
            2025-11-18 Notice Regarding End-Payer Plaintiffs’ Motion for Relief with Respect to False and Misleading Communications to Class Members
          </a>
        </li>
        <li>
          <a href="../../../assets/Docs/Motion Regarding Misleading Communications to Class Members.pdf" target="_blank">
            2025-11-11 End-Payer Plaintiffs’ Motion for Relief with Respect to False and Misleading Communications to Class Members
          </a>
        </li>
        <li>
          <a href="./assets/Docs/ApotexHeritageSettlements/2025-11-19 Final Order and Judgment Approving the Apotex and Heritage.pdf"
             target="_blank">
            2025-11-19 Final Order and Judgment Approving the Apotex and Heritage Settlements
          </a>
        </li>
        <li>
          <a href="./assets/Docs/ApotexHeritageSettlements/2025-11-19 Order Approving Attorneys' Fees as to Apotex and Heritage.pdf"
             target="_blank">
            2025-11-19 Order Approving Attorneys' Fees as to Apotex and Heritage Settlements
          </a>
        </li>
        <li>
          <a href="./assets/Docs/ApotexHeritageSettlements/2025-11-19 Memorandum and Opinion Approving the Apotex and Heritage.pdf"
             target="_blank">
            2025-11-19 Memorandum and Opinion Approving the Apotex and Heritage Settlements
          </a>
        </li>
        <li>
          <a href="./assets/Docs/ApotexHeritageSettlements/2025-06-24 EPP Class Counsel's Motion for Fees and Expenses (3486).pdf"
             target="_blank">
            2025-06-24 EPP Class Counsel's Motion for Fees and Expenses
          </a>
        </li>
        <li>
          <a href="../../../../assets/Docs/ApotexHeritageSettlements/2025-05-15 Order Setting Fairness Hrg for 10-3-2025 re EPP Apotex.pdf"
             target="_blank">
            2025-05-15 Order Setting the Date of the Final Fairness Hearing
          </a>
        </li>
        <li>
          <a href="./assets/Docs/ApotexHeritageSettlements/2025-05-14 Order Granting Motion for Approval.pdf"
             target="_blank">
            2025-05-14 Order Granting Motion for Approval of Notice Plans, Appointment of Notice Administrators, and Preliminary Approval of
            TPP Allocation Plan and Consumer Allocation Framework
          </a>
        </li>
        <li>
          <a href="../../../../assets/Docs/ApotexHeritageSettlements/ECF 3314 EPPs' Motion for Approval of Notice Plans.pdf"
             target="_blank">
            2025-03-31 Motion for Approval of Notice Plans, Appointment of Notice Administrators, and Preliminary Approval of TPP Allocation Plan and
            Consumer Allocation Framework
          </a>
        </li>
      </ul>
      <h6>Court Documents Relating to the Apotex Settlement</h6>
      <ul>
        <li>
          <a href="./assets/Docs/Relating to the Apotex Settlement/2025-09-22 EPPs' Motion for Final Approval of Apotex Settlement (3695).pdf"
             target="_blank">
            2025-09-22 EPPs' Motion for Final Approval of Apotex Settlement
          </a>
        </li>
        <li>
          <a href="./assets/Docs/Relating to the Apotex Settlement/2025-05-14 Order Granting Preliminary Approval.pdf"
             target="_blank">
            2025-05-14 Order Granting Preliminary Approval of Apotex Settlement
          </a>
        </li>
        <li>
          <a href="./assets/Docs/Relating to the Apotex Settlement/ECF 3312 EPPs' Motion for Preliminary Approval.pdf"
             target="_blank">
            Motion for Preliminary Approval of Apotex Settlement
          </a>
        </li>
        <li>
          <a href="./assets/Docs/Relating to the Apotex Settlement/Apotex Settlement Agreement.pdf"
             target="_blank">
            Apotex Settlement Agreement
          </a>
        </li>
        <li>
          <a href="./assets/Docs/Relating to the Apotex Settlement/Proposed TPP Allocation Plan.pdf"
             target="_blank">
            Proposed TPP Allocation Plan
          </a>
        </li>
      </ul>
      <h6>Court Documents Relating to the Heritage Settlement</h6>
      <ul>
        <li>
          <a href="./assets/Docs/Relating to the Heritage Settlement/2025-09-22 EPPs' Motion for Final Approval of Heritage Settlement (3697).pdf"
             target="_blank">
            2025-09-22 EPPs' Motion for Final Approval of Heritage Settlement
          </a>
        </li>
        <li>
          <a href="./assets/Docs/Relating to the Heritage Settlement/2024-06-26 Order Granting EPPs' Heritage Settlement (Doc. 3020).pdf"
             target="_blank">
            2024-06-26 Order Granting Preliminary Approval of Heritage Settlement
          </a>
        </li>
        <li>
          <a href="./assets/Docs/Relating to the Heritage Settlement/2024-06-12 EPPs' Motion for Preliminary Approval.pdf"
             target="_blank">
            2024-06-12 Motion for Preliminary Approval of Heritage Settlement
          </a>
        </li>
        <li>
          <a href="./assets/Docs/Relating to the Heritage Settlement/Heritage Settlement Agreement.pdf"
             target="_blank">
            Heritage Settlement Agreement
          </a>
        </li>
        <li>
          <a href="./assets/Docs/Relating to the Heritage Settlement/Proposed TPP Allocation Plan.pdf"
             target="_blank">
            Proposed TPP Allocation Plan
          </a>
        </li>
      </ul>
      <b>Complaints</b>

      <ul>
        <li>
          <a href="./assets/Docs/epp-albuterol-amended-complaint-public-doc-108.pdf"
             target="_blank">
            2019-04-01 EPP Albuterol Amended Complaint (PUBLIC)
          </a>
        </li>
        <li>
          <a href="./assets/Docs/epp-amitriptyline-amended-complaint-public-doc-100.pdf"
             target="_blank">
            2019-04-01 EPP Amitriptyline Amended Complaint (PUBLIC)
          </a>
        </li>
        <li>
          <a href="./assets/Docs/epp-baclofen-amended-complaint-public-doc-106.pdf"
             target="_blank">
            2019-04-01 EPP Baclofen Amended Complaint (PUBLIC)
          </a>
        </li>
        <li>
          <a href="./assets/Docs/epp-benazepril-amended-complaint-public-doc-88.pdf"
             target="_blank">
            2019-04-01 EPP Benazepril Amended Complaint (PUBLIC)
          </a>
        </li>
        <li>
          <a href="./assets/Docs/epp-clobetasol-amended-complaint-public-doc-167.pdf"
             target="_blank">
            2019-04-01 EPP Clobetasol Amended Complaint (PUBLIC)
          </a>
        </li>
        <li>
          <a href="./assets/Docs/epp-clomipramine-corrected-amended-complaint-public-doc-133.pdf"
             target="_blank">
            2019-06-25 EPP Clomipramine CORRECTED Amended Complaint (PUBLIC)
          </a>
        </li>
        <li>
          <a href="./assets/Docs/epp-desonide-2d-amended-complaint-public-doc-178.pdf"
             target="_blank">
            2020-09-04 EPP Desonide Second Amended Complaint (PUBLIC)
          </a>
        </li>
        <li>
          <a href="./assets/Docs/epp-digoxin-corrected-amended-complaint-public-doc-172.pdf"
             target="_blank">
            2019-06-25 EPP Digoxin CORRECTED Amended Complaint (PUBLIC)
          </a>
        </li>
        <li>
          <a href="./assets/Docs/epp-divalproex-amended-complaint-public-doc-123.pdf"
             target="_blank">
            2019-04-01 EPP Divalproex Amended Complaint (PUBLIC)
          </a>
        </li>
        <li>
          <a href="./assets/Docs/epp-doxycycline-2d-amended-complaint-public-doc-193.pdf"
             target="_blank">
            2019-04-01 EPP Doxycycline Second Amended Complaint (PUBLIC)
          </a>
        </li>
        <li>
          <a href="./assets/Docs/epp-econazole-3d-amended-complaint-public-doc-162.pdf"
             target="_blank">
            2020-10-16 EPP Econazole Third Amended Complaint (PUBLIC)
          </a>
        </li>
        <li>
          <a href="./assets/Docs/epp-fluocinonide-2d-amended-complaint-public-doc-150.pdf"
             target="_blank">
            2020-09-04 EPP Fluocinonide Second Amended Complaint (PUBLIC)
          </a>
        </li>
        <li>
          <a href="./assets/Docs/epp-levothyroxine-amended-complaint-public-doc-109.pdf"
             target="_blank">
            2019-04-01 EPP Levothyroxine Amended Complaint (PUBLIC)
          </a>
        </li>
        <li>
          <a href="./assets/Docs/epp-lido-prilo-amended-complaint-public-doc-112.pdf"
             target="_blank">
            2019-04-01 EPP Lidocaine-Prilocaine Amended Complaint (PUBLIC)
          </a>
        </li>
        <li>
          <a href="./assets/Docs/epp-pravastatin-amended-complaint-public-doc-152.pdf"
             target="_blank">
            2019-04-01 EPP Pravastatin Amended Complaint (PUBLIC)
          </a>
        </li>
        <li>
          <a href="./assets/Docs/epp-propranolol-amended-complaint-public-doc-131.pdf"
             target="_blank">
            2019-04-01 EPP Propranolol Amended Complaint (PUBLIC)
          </a>
        </li>
        <li>
          <a href="./assets/Docs/epp-ursodiol-amended-complaint-public-doc-112.pdf"
             target="_blank">
            2019-04-19 EPP Ursodiol Amended Complaint (PUBLIC)
          </a>
        </li>
        <li>
          <a href="./assets/Docs/epp-first-multi-drug-complaint-amended-public-doc-153.pdf"
             target="_blank">
            2019-04-19 EPP First Multi-Drug Complaint (Amended) (PUBLIC)
          </a>
        </li>
        <li>
          <a href="./assets/Docs/epp-second-multi-drug-complaint-second-amended-public-doc-78-2.pdf"
             target="_blank">
            2020-12-15 EPP Second Multi-Drug Complaint (Second Amended) (PUBLIC)
          </a>
        </li>
      </ul>
    </div>
  </div>
  <br />
  <br />
  <div style="width:80%; margin:0 auto; text-align: center; display:block; margin-top: 2%">
    <p>
      Note: These documents are in PDF format. To view the<br />
      documents, you will need <a href="https://get.adobe.com/reader/" target="_blank"
                                  style="color:#C40A0A; font-weight:bold">Adobe Acrobat Reader</a>
      on your computer or other internet-enabled device.
    </p>
  </div>
  <div class="row text-center" id="inverse_row">
    <div class="col-md-12">
      <a href="https://get.adobe.com/reader/" target="_blank"><img src="../assets/adobe-pdf-icon.jpg" alt="Adobe Acrobat Reader" width="3%"></a>
    </div>
  </div>
  <br />
  <br />
</div>
